var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6793 6.24024C16.9722 5.94735 17.4471 5.94735 17.7399 6.24024C18.0328 6.53313 18.0328 7.00801 17.7399 7.3009L13.0507 11.9901L17.74 16.6793C18.0329 16.9722 18.0329 17.4471 17.74 17.74C17.4471 18.0329 16.9722 18.0329 16.6793 17.74L11.9901 13.0508L7.30084 17.74C7.00794 18.0329 6.53307 18.0329 6.24018 17.74C5.94728 17.4471 5.94728 16.9722 6.24018 16.6794L10.9294 11.9901L6.24019 7.3009C5.9473 7.00801 5.9473 6.53313 6.24019 6.24024C6.53308 5.94735 7.00796 5.94735 7.30085 6.24024L11.9901 10.9295L16.6793 6.24024Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ef51ac4e0ddec9805657caea1f40c9a1.svg";
export { ForwardRef as ReactComponent };